import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
Fancybox.bind('[data-fancybox]', {});